<template>
  <v-card elevation="2" class="center-element">
    <v-card-title color="secondary"><strong>{{title}} progress photos</strong>
    </v-card-title>
    <v-card-subtitle>First and last check-in images</v-card-subtitle>

    <v-row>
      <v-col cols="6" align="center">
        <v-icon v-if="firstImage" color="secondary" @click="download(firstImage, `${title}-first`)">save_alt</v-icon>
      </v-col>
      <v-col cols="6" align="center">
        <v-icon v-if="lastImage" color="secondary" @click="download(lastImage, `${title}-last`)">save_alt</v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="6" class="pt-0 pr-0 pl-5 pb-5">
        <v-img v-if="firstImage" :src="firstImage"/>
        <v-card-text v-else  class="larger-text">
          Client has not uploaded an image on their first completed assessment
        </v-card-text>
      </v-col>
      <v-col cols="6" class="pt-0 pl-0 pr-5 pb-5">
        <v-img v-if="lastImage" :src="lastImage"/>
        <v-card-text v-else class="larger-text">
          Client has not uploaded an image on their last completed assessment
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FileDownloadMixin from '@/components/shared/mixins/FileDownloadMixin'; 
export default {
  name: "ClientProgressPhoto",
  mixins: [FileDownloadMixin],
  props: ["title", "firstImage", "lastImage"]
}
</script>

<style scoped> 
.larger-text {
  font-size: large;
}
</style>